export default __webpack_public_path__ + "static/media/product-banner.490352fe.png";